import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ReferencedLearningActivity } from "types";
import { LearningActivityGenericContent } from "./LearningActivityGenericContent.component";
import { LearningActivityVirtualClassroomContent } from "./LearningActivityVirtualClassroomContent.component";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { CommonModal } from "../../components/Commons/Modal.component";

type ILearningActivityModal = {
  buttonType?: "filter" | "primary" | "secondary" | "icononly" | "tertiary" | "linkState";
  buttonLabel?: string;
  activity: ReferencedLearningActivity
  customButton?: React.ReactNode,
  setOpen:React.Dispatch<React.SetStateAction<boolean>>,
  open:boolean
}

export const LearningActivityModal = ({
  buttonType,
  buttonLabel,
  activity,
  customButton,
  setOpen,
  open
}: ILearningActivityModal) => {

  const { t } = useTranslation();

  const handleClose = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    setOpen(false);
  };

  const handleActivityContent = (activity: ReferencedLearningActivity) => {
    switch (activity.learningObjectTypology) {
    case "DA_VIRTUAL_CLASS":
    case "DA_PHYSICAL_CLASS":
      return (
        <LearningActivityVirtualClassroomContent
          activity={ activity }
          handleClose={ handleClose }
        />
      );

    default:
      return (
        <LearningActivityGenericContent
          activity={ activity }
          handleClose={ handleClose }
        />
      );
    }
  };

  return (
    <>
      { buttonType && <ButtonDigited
        typology={ buttonType }
        text={ buttonLabel || t("details") }
        onClick={ () => setOpen(true) }
      /> }
      { customButton && (
        <Box onClick={ () => setOpen(true) }>  
          { customButton }
        </Box>
      ) }
      <CommonModal
        open={ open }
        handleClose={ handleClose }
      >
        { handleActivityContent(activity) ?? <></> }
      </CommonModal>
    </>
  );
};
